import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getLatLonValues = (keys, data) => {
  if (keys.length === 1) return data[keys];
  const key = keys.shift();
  return getLatLonValues(keys, data[key]);
};
const getLatLong = (latProp, lonProp, shape, data) => {
  const {
    latitude,
    longitude
  } = shape;
  if (!latProp || !lonProp) return {
    latitude,
    longitude
  };
  const latKeys = latProp.split('.');
  const lonKeys = lonProp.split('.');
  const lat = getLatLonValues(latKeys, data);
  const lon = getLatLonValues(lonKeys, data);
  return {
    latitude: lat,
    longitude: lon
  };
};
const buildMapShapes = (shapesOptions, shapesData) => {
  if (!shapesData) return [];
  const mapShapes = [];
  shapesOptions.forEach(shape => {
    const {
      shapeKey,
      entityOptions,
      shapeOptions
    } = shape;
    const {
      dataSummaries,
      enableInfoPane
    } = entityOptions;
    const shapeData = Array.isArray(shapesData[shapeKey]) ? shapesData[shapeKey] : shapesData[shapeKey].results;
    if (!shapeData) return;
    const {
      latProp,
      lonProp
    } = entityOptions;
    shapeData.forEach(data => {
      const {
        url
      } = data;
      const {
        latitude,
        longitude
      } = getLatLong(latProp, lonProp, shapeOptions, data);
      const formatedShape = _objectSpread(_objectSpread({}, shapeOptions), {}, {
        latitude,
        longitude,
        dataSummaries,
        enableInfoPane,
        url,
        shapeData: data
      });
      mapShapes.push(formatedShape);
    });
  });
  return mapShapes;
};
export default buildMapShapes;
//# sourceMappingURL=build-map-shapes.js.map